<dashboardnav>
  <cradua-year-of-suit [yearofsuits]="yearofsuits$ | async" (yearofsuit)="onSubmitYearOfSuit($event)"
    (deleteYearOfSuitEvent)="onDeleteYearOfSuit($event)" *ngIf="(isLoadingYearOfSuit$ | async ) === false">
  </cradua-year-of-suit>

  <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingYearOfSuit$ | async) === true">
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
